import React from 'react';
import { map } from 'lodash';
import AccountCardHomePage from './AccountCardHomePage';
import NBABL from '../nba/NBABL';
import UpdateCard from '../nba/UpdateCard';
import ProductCard from '../nba/ProductCard';
import ArrayUtils from '../../utils/ArrayUtils';
import QuickLinksTile from './QuickLinksTile';
import { shouldShowQuickLinks } from './HomepageTilesUtils';
import { isVMBusiness } from '../../utils/BrandUtils';

const HomepageTilesAccounts = ({
  accounts,
  content,
  updates,
  products,
  invokeModal,
  goToAccountDetails,
}) => {
  let accountCards = [];
  map(accounts, (account, index) => {
    accountCards.push(
      <AccountCardHomePage
        key={`HomepageTilesAccounts_AccountCardHomePage_${index}`}
        content={content}
        account={account}
        index={index}
        goToAccountDetails={goToAccountDetails}
      />
    );
  });
  NBABL.addNBAOnPosition(
    accountCards,
    3,
    <UpdateCard
      data={updates}
      action={invokeModal}
      key={'manual_splice_UpdateCard'}
    />
  );
  NBABL.addNBAOnPosition(
    accountCards,
    5,
    <ProductCard
      data={products}
      action={invokeModal}
      key={'manual_splice_ProductCard'}
    />
  );
  if (shouldShowQuickLinks()) {
    const tilePosition = isVMBusiness() ? 2 : 7;
    accountCards = ArrayUtils.addTileAtPosition(
      accountCards,
      tilePosition,
      <QuickLinksTile key={'manual_splice_QuickLinksTile'} />
    );
  }
  return [...accountCards];
};

export default HomepageTilesAccounts;
